(function () {
    function getBundlePropertyLabels(config) {
      const settings = window.themeVariables?.settings || {};
      return {
        addons: config?.addonsPropertyLabel || settings.addonsPropertyLabel || "_Addon",
        main: config?.mainProductPropertyLabel || settings.mainProductPropertyLabel || "_Main",
      };
    }
  
    function getLineProperty(item, key) {
      if (!item?.properties) return null;
      const value = item.properties[key];
      return value == null || value === "" ? null : String(value);
    }
  
    function getBundleTimestamp(item, labels) {
      return getLineProperty(item, labels.main) || getLineProperty(item, labels.addons);
    }
  
    function isBundleMain(item, labels) {
      return Boolean(getLineProperty(item, labels.main));
    }
  
    function isBundleAddon(item, labels) {
      return Boolean(getLineProperty(item, labels.addons));
    }
  
    function getMoneyFormat(format) {
      if (format) return format;
      const settings = window.themeVariables?.settings;
      if (settings?.currencyCodeEnabled && settings.moneyWithCurrencyFormat) {
        return settings.moneyWithCurrencyFormat;
      }
      return settings?.moneyFormat || "{{amount}}";
    }

    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = getMoneyFormat(format);

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        const parts = String(number).split(".");
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }

      const match = formatString.match(placeholderRegex);
      let value = "";
      switch (match ? match[1] : "amount") {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  
    function parseConfig(element) {
      const script = element.querySelector("[data-bundle-config]");
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.error("Bundle builder: invalid config JSON", e);
        return null;
      }
    }
  
    function buildProductLookup(config) {
      const map = new Map();
      const addProduct = (product, categoryId = "", categoryTitle = "") => {
        map.set(String(product.variantId), {
          ...product,
          categoryId,
          category: categoryTitle || product.category || "",
        });
      };
  
      (config.preselectedProducts || []).forEach((product) => {
        addProduct(product, "preselected", product.category || "");
      });
  
      (config.categories || []).forEach((category) => {
        (category.products || []).forEach((product) => {
          addProduct(product, category.id, category.title);
        });
      });
  
      return map;
    }
  
    function sortTiers(tiers) {
      return [...(tiers || [])].sort((a, b) => Number(a.max) - Number(b.max));
    }
  
    function sortFreeGifts(gifts) {
      return [...(gifts || [])].sort((a, b) => Number(a.minQuantity) - Number(b.minQuantity));
    }
  
    function prepareBundledSections() {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections },
        })
      );
      return sections;
    }

    const bundleConfigCache = new Map();
    const bundleProductFlagCache = new Map();

    function getProductHandleFromPath(pathname) {
      const parts = String(pathname || "").split("/").filter(Boolean);
      const productsIndex = parts.indexOf("products");
      if (productsIndex === -1 || !parts[productsIndex + 1]) return "";
      return decodeURIComponent(parts[productsIndex + 1].split("?")[0]);
    }

    function parseBundleConfigFromHtml(html) {
      if (!html) return null;
      const doc = new DOMParser().parseFromString(html, "text/html");
      const script = doc.querySelector("[data-bundle-config]");
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.error("Bundle builder: invalid config JSON", e);
        return null;
      }
    }

    async function fetchBundleConfigByHandle(handle) {
      if (!handle) return null;
      if (bundleConfigCache.has(handle)) return bundleConfigCache.get(handle);

      const request = (async () => {
        const root = window.Shopify?.routes?.root || "/";

        try {
          const sectionRes = await fetch(`${root}products/${handle}?section_id=main`, {
            credentials: "same-origin",
            headers: { Accept: "text/html" },
          });
          if (sectionRes.ok) {
            const config = parseBundleConfigFromHtml(await sectionRes.text());
            if (config) return config;
          }
        } catch (e) {
          console.error("Bundle builder: failed to load section config", e);
        }

        try {
          const pageRes = await fetch(`${root}products/${handle}`, {
            credentials: "same-origin",
            headers: { Accept: "text/html" },
          });
          if (pageRes.ok) {
            return parseBundleConfigFromHtml(await pageRes.text());
          }
        } catch (e) {
          console.error("Bundle builder: failed to load product config", e);
        }

        return null;
      })();

      bundleConfigCache.set(handle, request);
      try {
        const config = await request;
        if (!config) bundleConfigCache.delete(handle);
        return config;
      } catch (error) {
        bundleConfigCache.delete(handle);
        throw error;
      }
    }

    function emptyBundleProductInfo() {
      return { isBundleBuilder: false, bundleInitialPrice: "" };
    }

    async function fetchBundleProductInfo(handle) {
      if (!handle) return emptyBundleProductInfo();
      if (bundleProductFlagCache.has(handle)) return bundleProductFlagCache.get(handle);

      const request = (async () => {
        const root = window.Shopify?.routes?.root || "/";
        try {
          const response = await fetch(`${root}products/${handle}?view=bundle-info`, {
            credentials: "same-origin",
            headers: { Accept: "application/json, text/plain, */*" },
          });
          if (!response.ok) return emptyBundleProductInfo();
          const text = (await response.text()).trim();
          if (!text) return emptyBundleProductInfo();
          try {
            const parsed = JSON.parse(text);
            if (typeof parsed === "boolean") {
              return { isBundleBuilder: parsed, bundleInitialPrice: "" };
            }
            return {
              isBundleBuilder: Boolean(parsed?.isBundleBuilder),
              bundleInitialPrice: parsed?.bundleInitialPrice ? String(parsed.bundleInitialPrice).trim() : "",
            };
          } catch {
            const match = text.match(/"isBundleBuilder"\s*:\s*(true|false)/i);
            const priceMatch = text.match(/"bundleInitialPrice"\s*:\s*"((?:\\.|[^"\\])*)"/);
            return {
              isBundleBuilder: match ? match[1].toLowerCase() === "true" : false,
              bundleInitialPrice: priceMatch ? JSON.parse(`"${priceMatch[1]}"`) : "",
            };
          }
        } catch {
          return emptyBundleProductInfo();
        }
      })();

      bundleProductFlagCache.set(handle, request);
      return request;
    }

    async function submitBundleCart({ items, mainVariantId, form, submitButtons, onSuccessDo }) {
      const setBusy = (busy) => {
        (submitButtons || []).forEach((btn) => {
          if (busy) {
            btn.setAttribute("disabled", "disabled");
            btn.setAttribute("aria-busy", "true");
          } else {
            btn.removeAttribute("aria-busy");
            btn.removeAttribute("disabled");
          }
        });
      };

      setBusy(true);
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      try {
        const sectionsToBundle = prepareBundledSections();
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items,
            sections: sectionsToBundle.join(","),
            sections_url: `${Shopify.routes.root}variants/${mainVariantId}`,
          }),
        });

        const responseJson = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        setBusy(false);

        if (response.ok) {
          BundleCartSync.cartCache = null;

          if (
            window.themeVariables?.settings?.cartType === "page" ||
            window.themeVariables?.settings?.pageType === "cart"
          ) {
            window.location.href = `${Shopify.routes.root}cart`;
            return true;
          }

          const cartContent = await BundleCartSync.fetchCart(true);
          cartContent.sections = responseJson.sections || {};

          const eventDetail = {
            items: responseJson.items || [responseJson],
            cart: cartContent,
            onSuccessDo,
          };

          form?.dispatchEvent(
            new CustomEvent("variant:add", {
              bubbles: true,
              detail: eventDetail,
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent,
                onSuccessDo,
              },
            })
          );
          return true;
        }

        form?.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: responseJson.description || responseJson.message },
          })
        );
        return false;
      } catch (error) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        setBusy(false);
        form?.dispatchEvent(
          new CustomEvent("cart:error", { bubbles: true, detail: { error: error.message } })
        );
        return false;
      }
    }

    function defaultPreorderMessage() {
      return (
        window.themeVariables?.settings?.preorderBadgeText ||
        window.themeVariables?.strings?.preOrderBadge ||
        "Vorbestellung"
      );
    }

    function applyPreorderProperties(properties, preorderState) {
      if (!properties || !preorderState?.preorder) return properties;
      properties._preorder = "true";
      properties.Vorbestellung = preorderState.message || defaultPreorderMessage();
      return properties;
    }

    function getFormPreorderState(form) {
      if (!form) return null;
      const preorderInput = form.querySelector(
        '[name="properties[_preorder]"]:not([disabled])'
      );
      if (!preorderInput || preorderInput.value !== "true") return null;
      const messageInput = form.querySelector(
        '[name="properties[Vorbestellung]"]:not([disabled])'
      );
      return {
        preorder: true,
        message: messageInput?.value || defaultPreorderMessage(),
      };
    }
  
    const BundleCartSync = {
      isSyncing: false,
      cartCache: null,
      _pending: null,
      _editSession: null,
      _ratioCache: new Map(),
      _lastDisplay: null,
      _debounceTimer: null,
      _debounceMs: 250,
  
      init() {
        if (this._initialized) return;
        this._initialized = true;
  
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this._onQuantityInput = this._onQuantityInput.bind(this);
        this._onCartLinkClick = this._onCartLinkClick.bind(this);
        this._onCartChange = this._onCartChange.bind(this);
  
        document.addEventListener("change", this._onQuantityChange, true);
        document.addEventListener("input", this._onQuantityInput, true);
        document.addEventListener("click", this._onCartLinkClick, true);
        document.addEventListener("cart:change", this._onCartChange);
        this.fetchCart().catch(() => {});
        this._watchCartDom();
      },

      _watchCartDom() {
        if (this._addonDisplayObserver) return;
        this._addonDisplayObserver = new MutationObserver(() => {
          if (!this._lastDisplay || this._restoringDisplay) return;
          this._restoringDisplay = true;
          this._restoreAddonDisplay(0);
          queueMicrotask(() => {
            this._restoringDisplay = false;
          });
        });
        const start = () => {
          const root =
            document.querySelector("cart-drawer") ||
            document.querySelector("form[action*='/cart']") ||
            document.body;
          if (root) this._addonDisplayObserver.observe(root, { childList: true, subtree: true });
        };
        if (document.body) start();
        else document.addEventListener("DOMContentLoaded", start);
      },
  
      async fetchCart(force = false) {
        if (!force && this.cartCache) return this.cartCache;
        const response = await fetch(`${Shopify.routes.root}cart.js`, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error("Failed to load cart");
        this.cartCache = await response.json();
        return this.cartCache;
      },
  
      get labels() {
        return getBundlePropertyLabels();
      },

      _escapeSelector(value) {
        if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
          return CSS.escape(String(value));
        }
        return String(value).replace(/"/g, '\\"');
      },

      _getLineItemEl(node) {
        if (!node?.closest) return null;
        return (
          node.closest("line-item") ||
          node.closest("[data-bundle-role]") ||
          node.closest("tr")?.querySelector("line-item") ||
          null
        );
      },

      _getCachedLine(lineKey) {
        return this.cartCache?.items?.find((item) => item.key === lineKey) || null;
      },

      _getBundleRole(lineItemEl, lineKey) {
        const roleHost = lineItemEl?.closest?.("[data-bundle-role]") || lineItemEl;
        const role = roleHost?.dataset?.bundleRole;
        if (role === "main" || role === "addon") return role;
        if (roleHost?.classList.contains("line-item--bundle-main") || lineItemEl?.classList.contains("line-item--bundle-main")) {
          return "main";
        }
        if (roleHost?.classList.contains("line-item--bundle-addon") || lineItemEl?.classList.contains("line-item--bundle-addon")) {
          return "addon";
        }

        const cached = this._getCachedLine(lineKey);
        if (!cached) return null;
        if (isBundleMain(cached, this.labels)) return "main";
        if (isBundleAddon(cached, this.labels)) return "addon";
        return null;
      },

      _shouldIntercept(lineItemEl, lineKey, targetQuantity) {
        const role = this._getBundleRole(lineItemEl, lineKey);
        if (role === "main") return true;
        if (role === "addon" && targetQuantity <= 0) return true;
        return false;
      },
  
      getChildren(cart, bundleTimestamp) {
        const labels = this.labels;
        return cart.items.filter(
          (item) =>
            isBundleAddon(item, labels) && getLineProperty(item, labels.addons) === bundleTimestamp
        );
      },
  
      getParent(cart, bundleTimestamp) {
        const labels = this.labels;
        return cart.items.find(
          (item) => isBundleMain(item, labels) && getLineProperty(item, labels.main) === bundleTimestamp
        );
      },
  
      getBundleLines(cart, bundleTimestamp) {
        const labels = this.labels;
        return cart.items.filter((item) => getBundleTimestamp(item, labels) === bundleTimestamp);
      },
  
      buildRemoveBundleUpdates(cart, bundleTimestamp) {
        const updates = {};
        this.getBundleLines(cart, bundleTimestamp).forEach((item) => {
          updates[item.key] = 0;
        });
        return Object.keys(updates).length ? updates : null;
      },
  
      async removeBundle(cart, bundleTimestamp) {
        if (bundleTimestamp) this._ratioCache.delete(bundleTimestamp);
        if (this._editSession) this._editSession = null;
        this._lastDisplay = null;
        const updates = this.buildRemoveBundleUpdates(cart, bundleTimestamp);
        if (!updates) return null;
        return this.applyUpdates(updates);
      },
  
      getQtyPerParent(child, parent) {
        const stored = Number(getLineProperty(child, "_bundle_qty_per_parent"));
        if (Number.isFinite(stored) && stored > 0) return stored;

        const parentQty = Number(parent?.quantity) || 0;
        if (parentQty > 0) return child.quantity / parentQty;
        return child.quantity || 1;
      },

      _childIdentity(child) {
        const props = child?.properties && typeof child.properties === "object" ? child.properties : {};
        const keys = Object.keys(props).sort();
        const signature = keys.map((key) => `${key}=${props[key]}`).join("&");
        return `${child.variant_id}:${signature}`;
      },

      _getChildRatios(cart, parentLine) {
        const bundleTimestamp = getBundleTimestamp(parentLine, this.labels);
        if (bundleTimestamp && this._ratioCache.has(bundleTimestamp)) {
          return this._ratioCache.get(bundleTimestamp);
        }

        const ratios = { byKey: {}, byIdentity: {} };
        this.getChildren(cart, bundleTimestamp).forEach((child) => {
          const ratio = this.getQtyPerParent(child, parentLine);
          ratios.byKey[child.key] = ratio;
          ratios.byIdentity[this._childIdentity(child)] = ratio;
        });

        if (bundleTimestamp) this._ratioCache.set(bundleTimestamp, ratios);
        return ratios;
      },
  
      buildChildQuantity(qtyPerParent, parentQuantity) {
        if (parentQuantity <= 0) return 0;
        return Math.max(0, Math.round(qtyPerParent * parentQuantity));
      },

      _qtyPerParentForChild(child, parentLine, ratios) {
        return (
          ratios?.byKey?.[child.key] ??
          ratios?.byIdentity?.[this._childIdentity(child)] ??
          this.getQtyPerParent(child, parentLine)
        );
      },
  
      buildUpdatesForParent(cart, parentLine, targetParentQuantity, ratios) {
        const bundleTimestamp = getBundleTimestamp(parentLine, this.labels);
        if (!bundleTimestamp) return null;
  
        const updates = { [parentLine.key]: targetParentQuantity };
        const children = this.getChildren(cart, bundleTimestamp);
  
        children.forEach((child) => {
          const qtyPerParent = this._qtyPerParentForChild(child, parentLine, ratios);
          updates[child.key] = this.buildChildQuantity(qtyPerParent, targetParentQuantity);
        });
  
        return updates;
      },

      _updatesMatchCart(cart, updates) {
        return Object.entries(updates).every(([key, qty]) => {
          const item = cart.items.find((line) => line.key === key);
          if (qty === 0) return !item;
          return Boolean(item) && item.quantity === qty;
        });
      },
  
      async applyUpdates(updates) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  
        const sectionsToBundle = prepareBundledSections();
  
        try {
          const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            credentials: "same-origin",
            body: JSON.stringify({
              updates,
              sections: sectionsToBundle.join(","),
            }),
          });
  
          const cartContent = await response.json();
          if (!response.ok) {
            throw new Error(cartContent.description || cartContent.message || "Cart update failed");
          }
  
          this.cartCache = cartContent;
          this._restoreAddonDisplay();
  
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "bundle:cart-sync",
                cart: cartContent,
              },
            })
          );

          this._restoreAddonDisplay(50);
          this._restoreAddonDisplay(300);

          if (window.themeVariables?.settings?.pageType === "cart") {
            window.location.reload();
          }
  
          return cartContent;
        } catch (error) {
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          this.cartCache = null;
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          throw error;
        }
      },
  
      async syncParentLine(parentLine, targetQuantity, cart, ratios) {
        const sourceCart = cart || this.cartCache;
        const bundleTimestamp = getBundleTimestamp(parentLine, this.labels);
  
        if (!bundleTimestamp || targetQuantity <= 0) {
          if (!bundleTimestamp) return null;
          return this.removeBundle(sourceCart, bundleTimestamp);
        }
  
        const updates = this.buildUpdatesForParent(sourceCart, parentLine, targetQuantity, ratios);
        if (!updates) return null;
        this._lastDisplay = {
          lineKey: parentLine.key,
          targetQuantity,
          updates,
          cart: sourceCart,
        };
        this._applyOptimisticQuantities(parentLine.key, targetQuantity, updates, sourceCart);
        if (this._updatesMatchCart(sourceCart, updates)) return sourceCart;
        return this.applyUpdates(updates);
      },
  
      async cleanupIncompleteBundles(cart) {
        const labels = this.labels;
        const timestamps = new Set();
  
        cart.items.forEach((item) => {
          const bundleTimestamp = getBundleTimestamp(item, labels);
          if (bundleTimestamp) timestamps.add(bundleTimestamp);
        });
  
        const updates = {};
        timestamps.forEach((bundleTimestamp) => {
          if (!this.getParent(cart, bundleTimestamp)) {
            this.getBundleLines(cart, bundleTimestamp).forEach((item) => {
              updates[item.key] = 0;
            });
          }
        });
  
        if (!Object.keys(updates).length) return cart;
        this.isSyncing = true;
        try {
          return await this.applyUpdates(updates);
        } finally {
          this.isSyncing = false;
          if (this._pending) this._flushBundleChange();
        }
      },
  
      async handleBundleLineChange(cart, lineKey, targetQuantity, ratios) {
        const labels = this.labels;
        const line = cart.items.find((item) => item.key === lineKey);
        if (!line) return false;
  
        const bundleTimestamp = getBundleTimestamp(line, labels);
        if (!bundleTimestamp) return false;
  
        if (targetQuantity <= 0) {
          await this.removeBundle(cart, bundleTimestamp);
          return true;
        }
  
        if (isBundleMain(line, labels)) {
          await this.syncParentLine(line, targetQuantity, cart, ratios);
          return true;
        }
  
        return false;
      },

      _getLineQuantityInput(lineKey) {
        if (!lineKey) return null;
        return document.querySelector(`[data-line-key="${this._escapeSelector(lineKey)}"]`);
      },

      _applyOptimisticQuantities(lineKey, targetQuantity, updates, cart) {
        const value = String(Math.max(0, targetQuantity));
        document.querySelectorAll(`[data-line-key="${this._escapeSelector(lineKey)}"]`).forEach((input) => {
          input.value = value;
          input.style.setProperty("--quantity-selector-character-count", `${value.length}ch`);
        });

        if (!updates) return;

        const sourceCart = cart || this.cartCache;
        const parentLine = sourceCart?.items?.find((item) => item.key === lineKey);
        const bundleTimestamp = parentLine ? getBundleTimestamp(parentLine, this.labels) : null;
        const qtyByVariant = {};
        const qtyByKey = {};

        Object.entries(updates).forEach(([key, qty]) => {
          qtyByKey[key] = Number(qty) || 0;
          const item = sourceCart?.items?.find((line) => line.key === key);
          if (!item || isBundleMain(item, this.labels)) return;
          const variantId = String(item.variant_id);
          qtyByVariant[variantId] = (qtyByVariant[variantId] || 0) + (Number(qty) || 0);
        });

        document.querySelectorAll("[data-bundle-addon-variant]").forEach((el) => {
          const variantId = el.getAttribute("data-bundle-addon-variant");
          const elBundle = el.getAttribute("data-bundle-addon-bundle");
          if (!variantId || !Object.prototype.hasOwnProperty.call(qtyByVariant, variantId)) return;
          if (bundleTimestamp && elBundle && elBundle !== bundleTimestamp) return;
          el.textContent = `${qtyByVariant[variantId]}x`;
        });

        document.querySelectorAll("[data-bundle-addon-qty]").forEach((el) => {
          if (el.hasAttribute("data-bundle-addon-variant")) return;
          const key = el.getAttribute("data-bundle-addon-qty");
          if (!key || !Object.prototype.hasOwnProperty.call(qtyByKey, key)) return;
          el.textContent = `${qtyByKey[key]}x`;
        });

        let combinedCents = 0;
        Object.entries(updates).forEach(([key, qty]) => {
          const item = sourceCart?.items?.find((line) => line.key === key);
          if (!item) return;
          const unitPrice = Number(item.final_price) || Number(item.price) || 0;
          combinedCents += unitPrice * (Number(qty) || 0);
        });

        const formattedTotal = formatMoney(combinedCents);
        const escapedKey = this._escapeSelector(lineKey);
        document.querySelectorAll(`[data-bundle-line-total="${escapedKey}"]`).forEach((el) => {
          el.textContent = formattedTotal;
        });
        document.querySelectorAll(`[data-bundle-combined-price="${escapedKey}"]`).forEach((el) => {
          const srOnly = el.querySelector(".sr-only");
          el.textContent = formattedTotal;
          if (srOnly) el.prepend(srOnly);
        });
      },

      _restoreAddonDisplay(delayMs = 0) {
        const display = this._lastDisplay;
        if (!display) return;
        const apply = () => {
          this._applyOptimisticQuantities(
            display.lineKey,
            display.targetQuantity,
            display.updates,
            display.cart
          );
        };
        if (delayMs > 0) {
          setTimeout(apply, delayMs);
          return;
        }
        apply();
      },

      _queueBundleChange(lineKey, targetQuantity, flushNow = false, debounceMs = this._debounceMs) {
        this._pending = {
          lineKey,
          targetQuantity: Math.max(0, targetQuantity),
        };

        const cart = this.cartCache;
        const parentLine = cart?.items?.find((item) => item.key === lineKey);
        if (parentLine && isBundleMain(parentLine, this.labels)) {
          if (!this._editSession || this._editSession.lineKey !== lineKey) {
            this._editSession = {
              lineKey,
              ratios: this._getChildRatios(cart, parentLine),
            };
          }
          const updates = this.buildUpdatesForParent(
            cart,
            parentLine,
            this._pending.targetQuantity,
            this._editSession.ratios
          );
          this._lastDisplay = {
            lineKey,
            targetQuantity: this._pending.targetQuantity,
            updates,
            cart,
          };
          this._applyOptimisticQuantities(lineKey, this._pending.targetQuantity, updates, cart);
        } else {
          this._applyOptimisticQuantities(lineKey, this._pending.targetQuantity);
        }

        clearTimeout(this._debounceTimer);
        if (flushNow) {
          this._flushBundleChange();
          return;
        }
        this._debounceTimer = setTimeout(() => {
          this._flushBundleChange();
        }, debounceMs);
      },

      async _flushBundleChange() {
        if (this.isSyncing) return;
        if (!this._pending) return;

        const pending = this._pending;
        this._pending = null;
        this.isSyncing = true;

        try {
          const cart = this.cartCache || (await this.fetchCart(true));
          const line = cart.items.find((item) => item.key === pending.lineKey);
          if (line && isBundleMain(line, this.labels)) {
            if (!this._editSession || this._editSession.lineKey !== pending.lineKey) {
              this._editSession = {
                lineKey: pending.lineKey,
                ratios: this._getChildRatios(cart, line),
              };
            }
          }

          const latest =
            this._pending?.lineKey === pending.lineKey ? this._pending : pending;
          if (this._pending?.lineKey === pending.lineKey) this._pending = null;

          await this.handleBundleLineChange(
            cart,
            latest.lineKey,
            latest.targetQuantity,
            this._editSession?.lineKey === latest.lineKey ? this._editSession.ratios : null
          );
        } catch (error) {
          console.error("Bundle cart sync:", error);
        } finally {
          this.isSyncing = false;
          if (this._pending) {
            this._flushBundleChange();
          }
        }
      },
  
      _onQuantityInput(event) {
        const input = event.target;
        if (!input?.matches?.("[data-line-key]")) return;

        const lineKey = input.getAttribute("data-line-key");
        const targetQuantity = parseInt(input.value, 10);
        if (!lineKey || !Number.isFinite(targetQuantity)) return;
        if (!this._shouldIntercept(this._getLineItemEl(input), lineKey, targetQuantity)) return;

        this._queueBundleChange(lineKey, targetQuantity, false, 400);
      },

      _onQuantityChange(event) {
        const input = event.target;
        if (!input?.matches?.("[data-line-key]")) return;

        const lineKey = input.getAttribute("data-line-key");
        const targetQuantity = parseInt(input.value, 10);
        if (!lineKey || !Number.isFinite(targetQuantity)) return;
        if (!this._shouldIntercept(this._getLineItemEl(input), lineKey, targetQuantity)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this._queueBundleChange(lineKey, targetQuantity, true);
      },
  
      _onCartLinkClick(event) {
        const link = event.target.closest('a[href*="/cart/change"], a.line-item-remove');
        if (!link) return;

        const lineItemEl = this._getLineItemEl(link);
        let lineKey;
        let urlQuantity = null;
        let isRemove = link.classList.contains("line-item-remove");

        if (link.href && link.href.includes("/cart/change")) {
          const url = new URL(link.href, window.location.origin);
          lineKey = url.searchParams.get("id");
          urlQuantity = parseInt(url.searchParams.get("quantity"), 10);
          if (urlQuantity === 0) isRemove = true;
        } else if (link.href) {
          try {
            const url = new URL(link.href, window.location.origin);
            lineKey = url.searchParams.get("id") || lineItemEl?.querySelector("[data-line-key]")?.getAttribute("data-line-key");
          } catch {
            lineKey = lineItemEl?.querySelector("[data-line-key]")?.getAttribute("data-line-key");
          }
          isRemove = true;
        }

        if (!lineKey) return;

        const input = lineItemEl?.querySelector("[data-line-key]") || this._getLineQuantityInput(lineKey);
        const liveQuantity = parseInt(input?.value, 10);
        let targetQuantity;

        if (isRemove) {
          targetQuantity = 0;
        } else if (Number.isFinite(liveQuantity) && Number.isFinite(urlQuantity)) {
          const selector = link.closest("quantity-selector");
          const qtyLinks = selector ? [...selector.querySelectorAll("a.quantity-selector__button")] : [];
          const isPlus = qtyLinks.length ? qtyLinks[qtyLinks.length - 1] === link : urlQuantity > liveQuantity;
          targetQuantity = isPlus ? liveQuantity + 1 : Math.max(0, liveQuantity - 1);
        } else if (Number.isFinite(urlQuantity)) {
          targetQuantity = urlQuantity;
        } else {
          return;
        }

        if (!this._shouldIntercept(lineItemEl, lineKey, targetQuantity)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const flushNow = window.themeVariables?.settings?.pageType === "cart";
        this._queueBundleChange(lineKey, targetQuantity, flushNow);
      },
  
      async _onCartChange(event) {
        if (event.detail?.baseEvent === "bundle:cart-sync") {
          this._restoreAddonDisplay(0);
          this._restoreAddonDisplay(200);
          this._restoreAddonDisplay(600);
          this._restoreAddonDisplay(1200);
          return;
        }

        if (this.isSyncing) return;
  
        const cart = event.detail?.cart;
        if (!cart?.items) return;
  
        this.cartCache = cart;
  
        const labels = this.labels;
        const needsCleanup = cart.items.some((item) => {
          if (!isBundleAddon(item, labels)) return false;
          const bundleTimestamp = getLineProperty(item, labels.addons);
          return bundleTimestamp && !this.getParent(cart, bundleTimestamp);
        });
  
        if (!needsCleanup) return;
  
        try {
          await this.cleanupIncompleteBundles(cart);
        } catch (error) {
          console.error("Bundle cart cleanup:", error);
        }
      },
    };
  
    class BundleBuilder extends HTMLElement {
      constructor() {
        super();
        this.config = null;
        this.productLookup = new Map();
        this.selection = new Map();
        this.popupDraft = new Map();
        this.preselectedIds = new Set();
        this.mainVariantPrice = 0;
        this.mainVariantCompareAtPrice = null;
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onVariantChange = this._onVariantChange.bind(this);
        this._onDocumentKeydown = this._onDocumentKeydown.bind(this);
      }
  
      connectedCallback() {
        this.config = parseConfig(this);
        if (!this.config) {
          console.error("Bundle builder: missing or invalid config JSON");
          return;
        }
  
        this.productLookup = buildProductLookup(this.config);
        this.tiers = sortTiers(this.config.discountTiers);
        this.freeGifts = sortFreeGifts(this.config.freeGifts);
        this.preselectedIds = new Set();
        this._initPreselected();
        this.mainVariantCompareAtPrice = this.config.mainCompareAtPrice ?? null;

        this._cacheElements();
        this._buildPopupTabs();
        this._bindEvents();
        this._renderAll();
        this._bindForm();
      }
  
      disconnectedCallback() {
        this._formBindObserver?.disconnect();
        this._formBindObserver = null;
        this.form?.removeEventListener("submit", this._onFormSubmit, true);
        this.form?.removeEventListener("variant:change", this._onVariantChange);
        if (this._qtyChangeHandler && this.form) {
          const qtyInput = this.form.querySelector('[name="quantity"]');
          qtyInput?.removeEventListener("change", this._qtyChangeHandler);
          qtyInput?.removeEventListener("input", this._qtyChangeHandler);
        }
        document.removeEventListener("keydown", this._onDocumentKeydown);
        this._restorePopupToHost();
        this._formBound = false;
      }
  
      _bindForm() {
        if (this._formBound) return;
  
        const formId = this.getAttribute("form");
        this.form = document.forms[formId];
  
        if (!this.form) {
          if (!this._formBindObserver) {
            this._formBindObserver = new MutationObserver(() => {
              this.form = document.forms[formId];
              if (this.form) {
                this._formBindObserver.disconnect();
                this._formBindObserver = null;
                this._attachToForm();
              }
            });
            this._formBindObserver.observe(document.documentElement, {
              childList: true,
              subtree: true,
            });
          }
          return;
        }
  
        this._attachToForm();
      }
  
      _attachToForm() {
        if (this._formBound || !this.form) return;
        this._formBound = true;
  
        this._readMainVariantPrice();
        this.form.addEventListener("submit", this._onFormSubmit, true);
        this.form.addEventListener("variant:change", this._onVariantChange);
  
        this._qtyChangeHandler = () => this._scheduleDisplayedPriceUpdate();
        const qtyInput = this.form.querySelector('[name="quantity"]');
        qtyInput?.addEventListener("change", this._qtyChangeHandler);
        qtyInput?.addEventListener("input", this._qtyChangeHandler);
        this._updateMinQuantityState();
      }
  
      _cacheElements() {
        this.selectionGrid = this.querySelector("[data-bundle-selection-grid]");
        this.popup = this.querySelector("[data-bundle-popup]");
        this.popupOverlay = this.querySelector("[data-bundle-popup-overlay]");
        this.popupDialog = this.querySelector(".bundle-popup__dialog");
        this.popupClose = this.querySelector("[data-bundle-popup-close]");
        this.popupTabs = this.querySelector("[data-bundle-popup-tabs]");
        this.popupPanels = this.querySelectorAll("[data-bundle-popup-panel]");
        this.popupConfirm = this.querySelector("[data-bundle-popup-confirm]");
        this.popupConfirmHeader = this.querySelector("[data-bundle-popup-confirm-header]");
      }
  
      _bindEvents() {
        this.popupConfirm?.addEventListener("click", () => this._confirmPopup());
        this.popupConfirmHeader?.addEventListener("click", () => this._confirmPopup());
        this.popupClose?.addEventListener("click", () => this._closePopup());
        this.popupOverlay?.addEventListener("click", () => this._closePopup());
        document.addEventListener("keydown", this._onDocumentKeydown);
  
        this.popup?.querySelectorAll("[data-bundle-product-card]").forEach((card) => {
          this._bindProductCard(card);
        });
      }
  
      _onDocumentKeydown(event) {
        if (event.key !== "Escape" || !this.popup?.classList.contains("is-open")) return;
        this._closePopup();
      }
  
      _movePopupToBody() {
        if (!this.popup || this.popup.parentElement === document.body) return;
        this._popupRestoreParent = this.popup.parentElement;
        this._popupRestoreNextSibling = this.popup.nextSibling;
        document.body.appendChild(this.popup);
      }
  
      _restorePopupToHost() {
        if (!this.popup || this.popup.parentElement !== document.body) return;
        const parent = this._popupRestoreParent;
        if (parent && parent.isConnected) {
          if (this._popupRestoreNextSibling && this._popupRestoreNextSibling.parentNode === parent) {
            parent.insertBefore(this.popup, this._popupRestoreNextSibling);
          } else {
            parent.appendChild(this.popup);
          }
        } else {
          this.appendChild(this.popup);
        }
        this._popupRestoreParent = null;
        this._popupRestoreNextSibling = null;
      }
  
      _openPopup() {
        if (!this.popup) return;
        this._movePopupToBody();
        this._syncPopupFromSelection();
        this.popup.hidden = false;
        this.popup.setAttribute("aria-hidden", "false");
        this.popup.classList.add("is-open");
        document.documentElement.classList.add("bundle-popup-open");
        if (this.shouldShowDiscountProgress()) {
          this._updateDiscountTracker();
        }
        this.popupDialog?.focus();
      }
  
      _closePopup() {
        if (!this.popup) return;
        this.popup.classList.remove("is-open");
        this.popup.hidden = true;
        this.popup.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("bundle-popup-open");
        this._restorePopupToHost();
      }
  
      _syncBundleQtyInput(input, quantity) {
        if (!input) return;
        const value = String(Math.max(0, quantity));
        input.value = value;
        input.style.setProperty("--quantity-selector-character-count", `${value.length}ch`);
      }
  
      _bindProductCard(card) {
        const variantId = String(card.dataset.variantId);
        const minus = card.querySelector("[data-bundle-qty-minus]");
        const plus = card.querySelector("[data-bundle-qty-plus]");
        const input = card.querySelector("[data-bundle-qty-input]");
  
        const adjustQuantity = (delta, event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const current = this.popupDraft.get(variantId)?.quantity || 0;
          this._setQuantity(variantId, current + delta, true);
        };
  
        minus?.addEventListener("click", (event) => adjustQuantity(-1, event), true);
        plus?.addEventListener("click", (event) => adjustQuantity(1, event), true);
  
        input?.addEventListener("change", () => {
          const value = parseInt(input.value, 10) || 0;
          this._setQuantity(variantId, value, true);
        });
  
        input?.addEventListener("input", () => {
          input.style.setProperty("--quantity-selector-character-count", `${input.value.length}ch`);
        });
      }
  
      _buildPopupTabs() {
        if (!this.popupTabs) return;
        this.popupTabs.innerHTML = "";
        const categories = this.config.categories || [];
  
        categories.forEach((category, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = `bundle-popup__tab${index === 0 ? " is-active" : ""}`;
          button.textContent = category.title;
          button.dataset.categoryId = category.id;
          button.addEventListener("click", () => this._activateCategory(category.id));
          this.popupTabs.appendChild(button);
        });
  
        if (categories[0]) this._activateCategory(categories[0].id);
      }
  
      _activateCategory(categoryId) {
        this.popupTabs?.querySelectorAll(".bundle-popup__tab").forEach((tab) => {
          tab.classList.toggle("is-active", tab.dataset.categoryId === categoryId);
        });
        this.popupPanels?.forEach((panel) => {
          panel.hidden = panel.dataset.categoryId !== categoryId;
        });
      }
  
      get isPreselectedMode() {
        const products = this.config?.preselectedProducts || [];
        return Boolean(
          this.config?.preselectedEnabled &&
          (products.length > 0 || this.preselectedIds.size > 0)
        );
      }
  
      _initPreselected() {
        if (!this.config?.preselectedEnabled) return;
  
        const products = this.config.preselectedProducts || [];
        if (!products.length) {
          console.warn(
            "Bundle builder: preselected mode is enabled but no preselected products were loaded. Check section settings."
          );
          return;
        }
  
        products.forEach((product) => {
          if (!product?.variantId || !product.available) return;
  
          const variantId = String(product.variantId);
          this.preselectedIds.add(variantId);
          this.selection.set(variantId, {
            ...product,
            quantity: 1,
            isPreselected: true,
          });
        });
      }
  
      isPreselectedItem(item) {
        return Boolean(item?.isPreselected);
      }
  
      isPreselectedVariant(variantId, map = this.selection) {
        const item = map.get(String(variantId));
        return this.isPreselectedItem(item);
      }
  
      get canRemovePreselected() {
        return Boolean(this.config.preselectedAllowRemove);
      }

      _getLockedPreselectedQuantity(variantId) {
        if (this.canRemovePreselected) return 0;
        return this.preselectedIds.has(String(variantId)) ? 1 : 0;
      }
  
      getActivePreselectedCount(map = this.selection) {
        let count = 0;
        map.forEach((item) => {
          if (item.quantity > 0 && item.isPreselected) count += 1;
        });
        return count;
      }
  
      getCustomerSelectionQty(map = this.selection) {
        let total = 0;
        map.forEach((item) => {
          if (item.quantity > 0 && !item.isPreselected) {
            total += item.quantity;
          }
        });
        return total;
      }
  
      getMaxCustomerSlots() {
        if (!this.isPreselectedMode) return this.config.maxProducts;
        return Math.max(0, this.config.maxProducts - this.getActivePreselectedCount());
      }
  
      getCustomerUniqueCount(map = this.selection) {
        let count = 0;
        map.forEach((item) => {
          if (item.quantity > 0 && !item.isPreselected) count += 1;
        });
        return count;
      }
  
      getTotalQuantity(map = this.selection) {
        let total = 0;
        map.forEach((item) => {
          total += item.quantity;
        });
        return total;
      }

      isMinQuantityEnabled() {
        return Boolean(this.config?.minQuantityEnabled) && Number(this.config.minQuantity) > 0;
      }

      getMinQuantity() {
        return Number(this.config?.minQuantity) || 0;
      }

      isBelowMinQuantity(map = this.selection) {
        if (!this.isMinQuantityEnabled()) return false;
        return this.getTotalQuantity(map) < this.getMinQuantity();
      }

      _getSubmitButtons() {
        const buttons = [];
        if (this.form) {
          Array.from(this.form.elements).forEach((el) => {
            if (el.type === "submit") buttons.push(el);
          });
        }

        const formId = this.config?.formId || this.getAttribute("form") || this.form?.id;
        if (formId) {
          document.querySelectorAll(`[type="submit"][form="${formId}"]`).forEach((btn) => {
            if (!buttons.includes(btn)) buttons.push(btn);
          });
        }

        return buttons;
      }

      _updateMinQuantityState() {
        if (!this.isMinQuantityEnabled()) return;

        const below = this.isBelowMinQuantity();
        const soldOut = this.config?.mainAvailable === false;
        const formId = this.config?.formId || this.getAttribute("form") || "";
        const shouldDisable = below || soldOut;

        this._getSubmitButtons().forEach((btn) => {
          if (shouldDisable) {
            btn.setAttribute("disabled", "disabled");
          } else if (!btn.hasAttribute("aria-busy")) {
            btn.removeAttribute("disabled");
          }
          btn.classList.toggle("is-bundle-min-locked", below);
        });

        if (formId) {
          document.querySelectorAll(`buy-buttons[form="${formId}"]`).forEach((el) => {
            el.classList.toggle("is-bundle-min-locked", below);
          });
          document.querySelectorAll(`[data-bundle-min-notice][data-form-id="${formId}"]`).forEach((notice) => {
            notice.hidden = !below;
          });
        }
      }
  
      getUniqueCount(map = this.selection) {
        let count = 0;
        map.forEach((item) => {
          if (item.quantity > 0) count += 1;
        });
        return count;
      }
  
      _getSortedSelectionItems(map = this.selection) {
        const expanded = [];
  
        map.forEach((item) => {
          const qty = Math.max(0, Number(item.quantity) || 0);
          if (qty <= 0) return;
  
          const unitCount = qty;
          for (let i = 0; i < unitCount; i++) {
            expanded.push({
              ...item,
              quantity: 1,
              _bundleUnitIndex: i,
              _bundleTotalQuantity: qty,
            });
          }
        });
  
        expanded.sort((a, b) => {
          if (a.isPreselected !== b.isPreselected) return a.isPreselected ? -1 : 1;
          return 0;
        });
  
        // Stamp slotIndex so discount/addon-property logic can target a single unit.
        expanded.forEach((item, index) => {
          item._bundleSlotIndex = index;
        });
  
        return expanded;
      }
  
      getConfiguredPreselectedCount() {
        return (this.config.preselectedProducts || []).length;
      }
  
      isDiscountAllProducts() {
        return this.config.discountApplication !== "milestone";
      }
  
      shouldShowDiscountProgress() {
        return Boolean(this.config.showDiscountProgress) && this.tiers.length > 0;
      }
  
      _getItemSlotIndex(item, map = this.selection) {
        const slotIndex = Number(item?._bundleSlotIndex);
        if (Number.isFinite(slotIndex) && slotIndex >= 0) return slotIndex;
  
        // Fallback for non-expanded objects (e.g. product cards / draft items):
        // return the first matching slot index, if any.
        const items = this._getSortedSelectionItems(map);
        return items.findIndex((entry) => String(entry.variantId) === String(item.variantId));
      }
  
      _getActiveDiscountTierForMap(map = this.selection) {
        return this._getActiveDiscountTier(this.getTotalQuantity(map));
      }
  
      _getTierForSlotInAllMode(slotIndex, totalQty) {
        if (!this.tiers.length || totalQty <= 0 || slotIndex < 0 || slotIndex >= totalQty) {
          return null;
        }

        // Highest unlocked tier applies to every selected product.
        return this._getActiveDiscountTier(totalQty);
      }

      _getPotentialSlotDiscountPercentAllMode(slotIndex) {
        // Empty slots only show a badge on the unlock slot for each tier
        // (e.g. 3rd → 10%, 6th → 15%). Applied discount on filled products
        // is handled separately via _getDiscountPercentForItem.
        const tier = this._getTierForSlot(slotIndex);
        if (!tier) return 0;
        return Number(tier.percent) || 0;
      }

      _getDiscountPercentForItem(item, map = this.selection) {
        const slotIndex = this._getItemSlotIndex(item, map);
        const totalQty = this.getTotalQuantity(map);

        if (this.isDiscountAllProducts()) {
          const tier = this._getTierForSlotInAllMode(slotIndex, totalQty);
          if (!tier) return 0;
          return Number(tier.percent) || 0;
        }

        if (item.isPreselected) return 0;

        const tierForThisSlot = this._getTierForSlot(slotIndex);
        if (!tierForThisSlot) return 0;

        if (totalQty < Number(tierForThisSlot.max)) return 0;

        return Number(tierForThisSlot.percent) || 0;
      }
  
      _getApplicableDiscountPercent(map = this.selection) {
        const active = this._getActiveDiscountTierForMap(map);
        return active ? Number(active.percent) || 0 : 0;
      }
  
      _itemQualifiesForAddonProperty(item, map = this.selection) {
        const slotIndex = this._getItemSlotIndex(item, map);
        if (slotIndex < 0) return false;

        const totalQty = this.getTotalQuantity(map);

        if (this.isDiscountAllProducts()) {
          const tier = this._getTierForSlotInAllMode(slotIndex, totalQty);
          return Boolean(tier?.addonPropertyName);
        }

        if (item.isPreselected) return false;

        const tierForThisSlot = this._getTierForSlot(slotIndex);
        if (!tierForThisSlot) return false;

        return totalQty >= Number(tierForThisSlot.max);
      }

      _getAddonPropertyForItem(item, map = this.selection) {
        if (!this._itemQualifiesForAddonProperty(item, map)) return null;

        const slotIndex = this._getItemSlotIndex(item, map);
        const totalQty = this.getTotalQuantity(map);
        const tierForThisSlot = this.isDiscountAllProducts()
          ? this._getTierForSlotInAllMode(slotIndex, totalQty)
          : this._getTierForSlot(slotIndex);
        const name = tierForThisSlot?.addonPropertyName;
        return name ? { name, value: "1" } : null;
      }
  
      _getDiscountTierSlotIndex(tier) {
        return Number(tier.max) - 1;
      }
  
      _getTierForSlot(slotIndex) {
        return this.tiers.find((tier) => this._getDiscountTierSlotIndex(tier) === slotIndex) || null;
      }
  
      _getSlotDiscountBadgePercent(slotIndex) {
        if (this.isDiscountAllProducts()) {
          return this._getPotentialSlotDiscountPercentAllMode(slotIndex);
        }

        const tier = this._getTierForSlot(slotIndex);
        if (!tier) return 0;
        return Number(tier.percent) || 0;
      }
  
      isSingleEmptySlotMode() {
        const value = this.config.showSingleEmptySlot;
        return value === true || value === "true";
      }
  
      _getVisibleSlotCount(filledCount) {
        const maxSlots = Number(this.config.maxProducts) || 1;
        if (!this.isSingleEmptySlotMode()) return maxSlots;
  
        return Math.min(filledCount + 1, maxSlots);
      }
  
      _getActiveDiscountTier(totalQty) {
        if (!this.tiers.length || totalQty <= 0) return null;
  
        let active = null;
        for (const tier of this.tiers) {
          if (totalQty >= Number(tier.max)) active = tier;
        }
        return active;
      }
  
      getDiscountPercent(totalQty) {
        const active = this._getActiveDiscountTier(totalQty);
        return active ? Number(active.percent) : 0;
      }
  
      getNextTier(totalQty) {
        if (!this.tiers.length) return null;
        for (const tier of this.tiers) {
          const max = Number(tier.max);
          if (totalQty < max) {
            return { remaining: max - totalQty, percent: Number(tier.percent) };
          }
        }
        return null;
      }
  
      getNextGiftTier(totalQty) {
        if (!this.freeGifts.length) return null;
        for (const gift of this.freeGifts) {
          if (!gift.available) continue;
          const min = Number(gift.minQuantity);
          if (totalQty < min) {
            return { remaining: min - totalQty, title: gift.title };
          }
        }
        return null;
      }
  
      getUnlockedGifts(totalQty) {
        const seen = new Set();
        const unlocked = [];
  
        for (const gift of this.freeGifts) {
          if (!gift.available) continue;
          if (totalQty < Number(gift.minQuantity)) continue;
  
          const variantId = String(gift.variantId);
          if (seen.has(variantId)) continue;
  
          seen.add(variantId);
          unlocked.push(gift);
        }
  
        return unlocked;
      }
  
      _getDiscountedUnitPrice(priceCents, item, map = this.selection) {
        const discount = item
          ? this._getDiscountPercentForItem(item, map)
          : this._getApplicableDiscountPercent(map);
        if (!discount) return priceCents;
        return Math.round((priceCents * (100 - discount)) / 100);
      }
  
      _getDiscountedAddonPrice(priceCents, item, map = this.selection) {
        return this._getDiscountedUnitPrice(priceCents, item, map);
      }
  
      _getDiscountedLineTotal(item, map = this.selection) {
        if (item.isPreselected && !this.isDiscountAllProducts()) {
          return item.price * item.quantity;
        }
        const unitPrice = this._getDiscountedUnitPrice(item.price, item, map);
        return unitPrice * item.quantity;
      }
  
      _formatProductPrice(cents) {
        return formatMoney(cents, this.config.moneyFormat);
      }
  
      _setQuantity(variantId, quantity, isPopup) {
        const variantKey = String(variantId);
        const map = isPopup ? this.popupDraft : this.selection;
        const existingItem = map.get(variantKey);
        const product = this.productLookup.get(variantKey) || existingItem;
        if (!product || product.available === false) return;

        const lockedMin = this._getLockedPreselectedQuantity(variantKey);
        quantity = Math.max(lockedMin, Math.min(quantity, this.config.maxQuantityPerProduct));

        const existingQty = Math.max(0, Number(existingItem?.quantity) || 0);
        const nextTotalQty = this.getTotalQuantity(map) - existingQty + quantity;
        if (quantity > existingQty && nextTotalQty > Number(this.config.maxProducts)) return;

        if (quantity === 0) {
          map.delete(variantKey);
        } else {
          const isPreselected = Boolean(
            existingItem?.isPreselected || product.isPreselected || this.preselectedIds.has(variantKey)
          );
          map.set(variantKey, {
            ...(existingItem || product),
            quantity,
            isPreselected,
          });
        }
  
        if (isPopup) {
          this._updatePopupUI();
        } else {
          this._renderAll();
        }
      }
  
      _syncPopupFromSelection() {
        this.popupDraft = new Map();
        this.selection.forEach((item, key) => {
          this.popupDraft.set(key, { ...item });
        });
        this._updatePopupUI();
      }
  
      _confirmPopup() {
        this.selection = new Map();
        this.popupDraft.forEach((item, key) => {
          if (item.quantity > 0) this.selection.set(key, { ...item });
        });
        this._closePopup();
        this._renderAll();
      }
  
      _updatePopupUI() {
        this.popup?.querySelectorAll("[data-bundle-product-card]").forEach((card) => {
          const variantId = String(card.dataset.variantId);

          const qty = this.popupDraft.get(variantId)?.quantity || 0;
          const input = card.querySelector("[data-bundle-qty-input]");
          const minus = card.querySelector("[data-bundle-qty-minus]");
          const plus = card.querySelector("[data-bundle-qty-plus]");
          const lockedMin = this._getLockedPreselectedQuantity(variantId);
          this._syncBundleQtyInput(input, qty);
          if (input) input.min = String(lockedMin);
          if (minus) minus.disabled = qty <= lockedMin;
          if (plus) {
            const atPerProductMax = qty >= Number(this.config.maxQuantityPerProduct);
            const atBundleMax = this.getTotalQuantity(this.popupDraft) >= Number(this.config.maxProducts);
            plus.disabled = atPerProductMax || atBundleMax;
          }
          card.classList.toggle("is-selected", qty > 0);
  
          const product = this.productLookup.get(variantId);
          const draftItem = this.popupDraft.get(variantId);
          const item = draftItem || product;
          const itemDiscount = item ? this._getDiscountPercentForItem(item, this.popupDraft) : 0;
          const badge = card.querySelector("[data-bundle-card-discount-badge]");
          const priceEl = card.querySelector("[data-bundle-card-price]");
          const compareEl = card.querySelector("[data-bundle-card-compare]");
  
          if (badge) {
            badge.hidden = itemDiscount <= 0;
            if (itemDiscount > 0) badge.textContent = `-${itemDiscount}%`;
          }
  
          if (product && priceEl) {
            const discounted = this._getDiscountedAddonPrice(
              product.price,
              item || product,
              this.popupDraft
            );
            priceEl.textContent = this._formatProductPrice(discounted);
            if (compareEl) {
              const showCompare = itemDiscount > 0 && product.compareAtPrice > discounted;
              compareEl.hidden = !showCompare;
              if (showCompare) {
                compareEl.textContent = this._formatProductPrice(product.compareAtPrice || product.price);
              }
            }
          }
        });
  
        if (this.shouldShowDiscountProgress()) {
          this._updateDiscountTracker();
        }
      }
  
      _renderAll() {
        this._renderSelectionGrid();
        this._hydrateSlotRatings();
        if (this.shouldShowDiscountProgress()) {
          this._updateDiscountTracker();
          this._updateNextTierMessage();
        }
        this._updateFreeGiftsUI();
        this._updateDisplayedPrice();
        this._updateMinQuantityState();
      }
  
      _renderSelectionGrid() {
        if (!this.selectionGrid) return;
        const items = this._getSortedSelectionItems();
        const filledCount = items.length;
        const visibleSlots = this._getVisibleSlotCount(filledCount);
  
        this.selectionGrid.innerHTML = "";
  
        for (let i = 0; i < visibleSlots; i++) {
          const item = items[i];
          const isNext = i === filledCount;
          this.selectionGrid.appendChild(
            item ? this._createFilledSlot(item, i) : this._createEmptySlot(isNext, i)
          );
        }
      }
  
      _getPopupRatingSource(variantId) {
        const card = this.popup?.querySelector(
          `[data-bundle-product-card][data-variant-id="${String(variantId)}"]`
        );
        if (!card) return null;
        return (
          card.querySelector("a[href*='product-rating']") ||
          card.querySelector(".product-rating")?.closest("a")
        );
      }
  
      _isRatingRendered(snippet) {
        if (!snippet) return false;
        return Boolean(
          snippet.querySelector("i, .ruk-rating-snippet-count, svg") ||
          (snippet.childElementCount > 0 && snippet.textContent.trim())
        );
      }
  
      _fillSlotRating(variantId, container, attempt = 0) {
        if (!container) return;
  
        const existing = container.querySelector(".ruk_rating_snippet");
        if (this._isRatingRendered(existing)) return;
  
        const source = this._getPopupRatingSource(variantId);
        const snippet = source?.querySelector(".ruk_rating_snippet");
  
        if (source && this._isRatingRendered(snippet)) {
          container.replaceChildren(source.cloneNode(true));
          return;
        }
  
        if (attempt < 20) {
          clearTimeout(container._bundleRatingRetry);
          container._bundleRatingRetry = setTimeout(
            () => this._fillSlotRating(variantId, container, attempt + 1),
            250
          );
        }
      }
  
      _hydrateSlotRatings() {
        this.selectionGrid?.querySelectorAll("[data-bundle-slot-rating]").forEach((container) => {
          const variantId = container.closest(".bundle-slot--filled")?.dataset.variantId;
          if (variantId) this._fillSlotRating(variantId, container);
        });
      }
  
      _getDiscountTrackerRoots() {
        const roots = [...this.querySelectorAll("[data-bundle-discount]")];
  
        if (this.popup) {
          this.popup.querySelectorAll("[data-bundle-discount]").forEach((root) => {
            if (!roots.includes(root)) roots.push(root);
          });
        }
  
        return roots;
      }
  
      _updateDiscountTracker() {
        if (!this.shouldShowDiscountProgress()) return;
  
        this._getDiscountTrackerRoots().forEach((root) => {
          const isPopup = Boolean(this.popup?.contains(root));
          const map =
            isPopup && this.popup?.classList.contains("is-open") ? this.popupDraft : this.selection;
          const totalQty = this.getTotalQuantity(map);
  
          root.querySelectorAll("[data-bundle-discount-number]").forEach((el) => {
            const n = parseInt(el.dataset.bundleDiscountNumber, 10);
            el.classList.toggle("is-active", !Number.isNaN(n) && n > 0 && n <= totalQty);
          });
  
          const activeTier = this._getActiveDiscountTier(totalQty);
          const activeTierMax = activeTier ? Number(activeTier.max) : null;
  
          root.querySelectorAll("[data-bundle-discount-tier]").forEach((el) => {
            const max = parseInt(el.dataset.tierMax, 10);
            const unlocked = !Number.isNaN(max) && totalQty >= max;
            const isCurrent = unlocked && activeTierMax === max;
            el.classList.toggle("is-active", unlocked);
            el.classList.toggle("is-current", isCurrent);
          });
        });
      }
  
      _updateNextTierMessage() {
        if (!this.shouldShowDiscountProgress()) return;
  
        const el = this.querySelector("[data-bundle-discount-status]");
        if (!el) return;
  
        const template = this.config.texts?.discountNextTierText;
        const totalQty = this.getTotalQuantity(this.selection);
        const next = this.getNextTier(totalQty);
  
        if (!template || !next || next.remaining <= 0) {
          el.textContent = "";
          el.hidden = true;
          return;
        }
  
        const discountStr = `-${Number(next.percent).toFixed(2)}%`;
        const countStr = String(next.remaining);
        el.innerHTML = template
          .replace("[count]", `<strong>${countStr}</strong>`)
          .replace("[discount]", `<strong>${discountStr}</strong>`);
        el.hidden = false;
      }
  
      _updateGiftLineFill(container, items, unlockedCount) {
        const lineFill = container.querySelector("[data-bundle-gifts-line-fill]");
        const line = container.querySelector(".bundle-gifts__line");
        if (!lineFill || !line) return;
  
        if (unlockedCount <= 0) {
          lineFill.style.height = "0px";
          return;
        }
  
        let lastUnlockedIndex = -1;
        items.forEach((item, index) => {
          if (item.classList.contains("is-unlocked")) lastUnlockedIndex = index;
        });
  
        const lastUnlockedItem = items[lastUnlockedIndex];
        const marker = lastUnlockedItem?.querySelector("[data-bundle-gift-marker]");
        if (!marker) {
          lineFill.style.height = "0px";
          return;
        }
  
        const updateHeight = () => {
          const lineRect = line.getBoundingClientRect();
          const markerRect = marker.getBoundingClientRect();
          const markerCenterY = markerRect.top + markerRect.height / 2 - lineRect.top;
          lineFill.style.height = `${Math.max(0, Math.round(markerCenterY))}px`;
        };
  
        updateHeight();
        requestAnimationFrame(updateHeight);
      }
  
      _updateFreeGiftsUI() {
        const container = this.querySelector("[data-bundle-gifts]");
        if (!container) return;
  
        const list = container.querySelector(".bundle-gifts__list");
        const items = [...container.querySelectorAll("[data-bundle-gift]")];
  
        if (list) {
          items
            .sort(
              (a, b) =>
                (parseInt(a.dataset.minQuantity, 10) || 0) - (parseInt(b.dataset.minQuantity, 10) || 0)
            )
            .forEach((item) => list.appendChild(item));
        }
        const totalQty = this.getTotalQuantity(this.selection);
        let unlockedCount = 0;
  
        items.forEach((item) => {
          const min = parseInt(item.dataset.minQuantity, 10) || 1;
          const unlocked = totalQty >= min;
          item.classList.toggle("is-unlocked", unlocked);
          if (unlocked) unlockedCount += 1;
        });
  
        this._updateGiftLineFill(container, items, unlockedCount);
  
        const statusEl = container.querySelector("[data-bundle-gifts-status]");
        if (!statusEl) return;
  
        const template = this.config.texts?.giftsNextTierText;
        const next = this.getNextGiftTier(totalQty);
  
        if (!template || !next || next.remaining <= 0) {
          statusEl.textContent = "";
          statusEl.hidden = true;
          return;
        }
  
        statusEl.innerHTML = template
          .replace("[count]", `<strong>${next.remaining}</strong>`)
          .replace("[gift]", `<strong>${next.title}</strong>`);
        statusEl.hidden = false;
      }
  
      _formatDiscountBadgePercent(percent) {
        const value = Number(percent) || 0;
        if (value <= 0) return "";
        const formatted = Number.isInteger(value) ? String(value) : value.toFixed(2);
        return `-${formatted}%`;
      }
  
      _formatSlotUnitPrice(item) {
        const measurement = item.unitPriceMeasurement;
        const unitPrice = Number(item.unitPrice);
        if (!measurement || unitPrice <= 0) return "";
  
        const refValue = measurement.referenceValue;
        const refUnit = measurement.referenceUnit;
        return `${this._formatProductPrice(unitPrice)} / ${refValue}${refUnit}`;
      }
  
      _getFilledSlotPricesMarkup(item) {
        const showPrices = Boolean(this.config.showSlotPrices);
        const showUnitPrice = Boolean(this.config.showSlotUnitPrice);
        if (!showPrices && !showUnitPrice) return "";
  
        const salePrice =
          item.isPreselected && !this.isDiscountAllProducts()
            ? item.price
            : this._getDiscountedUnitPrice(item.price, item, this.selection);
        const compareAt = this._getItemCompareAtUnitPrice(item);
        const showCompare = showPrices && compareAt > salePrice;
        const unitPriceLine = showUnitPrice ? this._formatSlotUnitPrice(item) : "";
  
        if (!showCompare && !showPrices && !unitPriceLine) return "";
        if (showPrices && !showCompare && !unitPriceLine && salePrice <= 0) return "";
  
        return `
          <div class="bundle-slot__prices">
            ${
              showCompare
                ? `<p class="bundle-slot__price-compare">${this._formatProductPrice(compareAt)}</p>`
                : ""
            }
            ${showPrices ? `<p class="bundle-slot__price">${this._formatProductPrice(salePrice)}</p>` : ""}
            ${unitPriceLine ? `<p class="bundle-slot__unit-price">${unitPriceLine}</p>` : ""}
          </div>
        `;
      }
  
      _createEmptySlot(isNext, slotIndex) {
        const discountPercent = this._getSlotDiscountBadgePercent(slotIndex);
        const badgeLabel = discountPercent > 0 ? this._formatDiscountBadgePercent(discountPercent) : "";
        const slot = document.createElement("button");
        slot.type = "button";
        slot.className = `bundle-slot bundle-slot--empty${isNext ? " is-next" : ""}`;
        slot.innerHTML = `
          ${badgeLabel ? `<span class="bundle-slot__badge">${badgeLabel}</span>` : ""}
          <span class="bundle-slot__plus" aria-hidden="true">
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
           <path d="M2.5 8H13.5" stroke="#ED8A00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M8 2.5V13.5" stroke="#ED8A00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </span>
          <span class="bundle-slot__label">${this.config.texts.addProductLabel}</span>
        `;
        slot.addEventListener("click", () => this._openPopup());
        return slot;
      }
  
      _createFilledSlot(item, slotIndex) {
        const isPreselected = item.isPreselected;
        const lockedMin = this._getLockedPreselectedQuantity(item.variantId);
        const unitIndex = Number(item._bundleUnitIndex) || 0;
        const showRemove = lockedMin === 0 || unitIndex >= lockedMin;
        const discountPercent = this._getDiscountPercentForItem(item, this.selection);
        const badgeLabel = discountPercent > 0 ? this._formatDiscountBadgePercent(discountPercent) : "";
        const showQtyBadge = true;
        const slot = document.createElement("div");
        slot.className = `bundle-slot bundle-slot--filled${isPreselected ? " bundle-slot--preselected" : ""}`;
        slot.dataset.variantId = item.variantId;
        slot.innerHTML = `
          <div class="bundle-slot__media-wrap">
            ${badgeLabel ? `<span class="bundle-slot__badge">${badgeLabel}</span>` : ""}
            ${item.image ? `<img class="bundle-slot__image" src="${item.image}" alt="" loading="lazy">` : ""}
            ${
              showRemove
                ? `<button type="button" class="bundle-slot__remove" data-bundle-remove aria-label="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"> <path d="M9.375 2.625L2.625 9.375" stroke="#D8C2AD" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9.375 9.375L2.625 2.625" stroke="#D8C2AD" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>`
                : ""
            }
            ${
              showQtyBadge
                ? `<span class="bundle-slot__qty-badge" aria-label="Quantity">${item.quantity}</span>`
                : ""
            }
          </div>
          <p class="bundle-slot__category">${item.category || ""}</p>
          <p class="bundle-slot__title">${item.title}</p>
          ${this._getFilledSlotPricesMarkup(item)}
          <div class="bundle-slot__rating" data-bundle-slot-rating></div>
        `;
  
        this._fillSlotRating(item.variantId, slot.querySelector("[data-bundle-slot-rating]"));
  
        if (showRemove) {
          slot.querySelector("[data-bundle-remove]")?.addEventListener("click", (e) => {
            e.stopPropagation();
            const variantId = String(item.variantId);
            const existing = this.selection.get(variantId);
            const currentQty = Math.max(0, Number(existing?.quantity) || 0);
            const nextQty = currentQty - 1;
            const minQty = this._getLockedPreselectedQuantity(variantId);
            if (nextQty < minQty) return;
            if (nextQty <= 0) {
              this.selection.delete(variantId);
            } else {
              this.selection.set(variantId, { ...existing, quantity: nextQty });
            }
            this._renderAll();
          });
        }
  
        return slot;
      }
  
      _readMainVariantPrice() {
        const idInput = this.form?.querySelector('[name="id"]');
        if (idInput?.value) this._fetchVariantPrice(idInput.value);
      }
  
      _onVariantChange(event) {
        const variant = event.detail?.variant;
        if (variant) {
          this.mainVariantPrice = variant.price;
          this.mainVariantCompareAtPrice = variant.compare_at_price;
          this._scheduleDisplayedPriceUpdate();
        }
      }
  
      _scheduleDisplayedPriceUpdate() {
        clearTimeout(this._displayPriceUpdateTimer);
        this._displayPriceUpdateTimer = setTimeout(() => this._updateDisplayedPrice(), 0);
      }
  
      async _fetchVariantPrice(variantId) {
        try {
          const res = await fetch(`${Shopify.routes.root}variants/${variantId}.js`);
          if (res.ok) {
            const variant = await res.json();
            this.mainVariantPrice = variant.price;
            this.mainVariantCompareAtPrice = variant.compare_at_price;
            this._scheduleDisplayedPriceUpdate();
          }
        } catch { }
      }
  
      _getMainQuantity() {
        const qtyInput = this.form?.querySelector('[name="quantity"]');
        return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      }
  
      _getMainLineTotal() {
        if (this.mainVariantPrice == null) return 0;
        return this.mainVariantPrice * this._getMainQuantity();
      }
  
      _getAddonsSubtotal(map = this.selection, applyDiscount = false) {
        if (!applyDiscount) {
          let subtotal = 0;
          map.forEach((item) => {
            if (item.quantity <= 0) return;
            subtotal += item.price * item.quantity;
          });
          return subtotal;
        }
  
        const slots = this._getSortedSelectionItems(map);
        return slots.reduce((sum, slotItem) => {
          if (slotItem.isPreselected && !this.isDiscountAllProducts()) {
            return sum + slotItem.price; // qty is always 1 in slots
          }
          return sum + this._getDiscountedUnitPrice(slotItem.price, slotItem, map);
        }, 0);
      }
  
      _setSalePriceText(salePrice, formatted) {
        for (const node of salePrice.childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = formatted;
            return;
          }
        }

        const textSpan = document.createElement("span");
        textSpan.textContent = formatted;
        salePrice.appendChild(textSpan);
      }

      _getItemCompareAtUnitPrice(item) {
        const price = Number(item?.price) || 0;
        const compareAt = Number(item?.compareAtPrice);
        return compareAt > 0 ? compareAt : price;
      }

      _getMainCompareAtUnitPrice() {
        const price = Number(this.mainVariantPrice) || 0;
        const compareAt = Number(this.mainVariantCompareAtPrice);
        return compareAt > 0 ? compareAt : price;
      }

      _getGiftCompareAtUnitPrice(gift) {
        const compareAt = Number(gift?.compareAtPrice);
        if (compareAt > 0) return compareAt;

        const price = Number(gift?.price) || 0;
        return price > 0 ? price : 0;
      }

      _getGiftCompareAtUnitPriceFromElement(giftEl) {
        const compareAt = Number(giftEl?.dataset?.giftCompareAt);
        if (compareAt > 0) return compareAt;

        const price = Number(giftEl?.dataset?.giftPrice) || 0;
        return price > 0 ? price : 0;
      }

      _getUnlockedGiftCompareAtTotal() {
        const unlockedGifts = this.querySelectorAll("[data-bundle-gift].is-unlocked");
        if (!unlockedGifts.length) return 0;

        const mainQty = this._getMainQuantity();
        let total = 0;

        unlockedGifts.forEach((giftEl) => {
          total += this._getGiftCompareAtUnitPriceFromElement(giftEl) * mainQty;
        });

        return total;
      }

      _getTotalCompareAtPrice() {
        const mainQty = this._getMainQuantity();
        let total = this._getMainCompareAtUnitPrice() * mainQty;

        this.selection.forEach((item) => {
          if (item.quantity <= 0) return;
          total += this._getItemCompareAtUnitPrice(item) * item.quantity;
        });

        total += this._getUnlockedGiftCompareAtTotal();

        return total;
      }

      _setCompareAtPriceText(compareAtPrice, formatted) {
        const lastChild = compareAtPrice.lastChild;
        if (lastChild?.nodeType === Node.TEXT_NODE) {
          lastChild.textContent = formatted;
          return;
        }

        if (lastChild?.nodeType === Node.ELEMENT_NODE && !lastChild.classList?.contains("sr-only")) {
          lastChild.replaceWith(document.createTextNode(formatted));
          return;
        }

        compareAtPrice.appendChild(document.createTextNode(formatted));
      }

      _updateDisplayedPrice() {
        const mainTotal = this._getMainLineTotal();
        const addonQty = this.getTotalQuantity(this.selection);
        const displayTotal =
          addonQty === 0
            ? mainTotal
            : mainTotal + this._getAddonsSubtotal(this.selection, true);
        const compareAtTotal = this._getTotalCompareAtPrice();
        const showCompare = compareAtTotal > displayTotal;

        const salePrices = document.querySelectorAll(`sale-price[form="${this.config.formId}"]`);
        if (salePrices.length) {
          const formatted = formatMoney(displayTotal, this.config.moneyFormat);

          salePrices.forEach((salePrice) => {
            this._setSalePriceText(salePrice, formatted);
            salePrice.classList.toggle("text-on-sale", showCompare);
            // Product prices use text-subdued when not on sale; remove it so
            // the sale accent color isn't overridden by later .text-subdued rules.
            if (showCompare) {
              salePrice.classList.remove("text-subdued");
            } else if (salePrice.classList.contains("h4")) {
              salePrice.classList.add("text-subdued");
            }
            salePrice.setAttribute("data-bundle-price-updated", "");
          });
        }

        const compareAtPrices = document.querySelectorAll(
          `compare-at-price[form="${this.config.formId}"]`
        );
        if (compareAtPrices.length) {
          const formattedCompare = formatMoney(compareAtTotal, this.config.moneyFormat);

          compareAtPrices.forEach((compareAtPrice) => {
            this._setCompareAtPriceText(compareAtPrice, formattedCompare);
            compareAtPrice.hidden = !showCompare;
          });
        }

        this._updateSavingText(displayTotal, compareAtTotal);

        this.dispatchEvent(
          new CustomEvent("bundle:price-change", {
            bubbles: true,
            detail: { price: displayTotal, compareAtPrice: compareAtTotal },
          })
        );
      }

      _updateSavingText(displayTotal, compareAtTotal) {
        const savingTextEl = document.querySelector(
          `[data-bundle-saving-text][data-form-id="${this.config.formId}"]`
        );
        if (!savingTextEl) return;

        const template = savingTextEl.dataset.savingTemplate || "";
        const savings = compareAtTotal - displayTotal;

        if (savings <= 0) {
          savingTextEl.hidden = true;
          savingTextEl.textContent = "";
          return;
        }

        savingTextEl.hidden = false;
        savingTextEl.textContent = template.replace(
          /\[amount\]/g,
          formatMoney(savings, this.config.moneyFormat)
        );
      }
  
      _getPreorderStateForVariant(variantId) {
        const id = String(variantId || "");
        if (!id) return null;

        const product = this.productLookup.get(id);
        if (product?.preorder) {
          return {
            preorder: true,
            message: product.preorderMessage || defaultPreorderMessage(),
          };
        }

        const gift = (this.freeGifts || []).find((item) => String(item.variantId) === id);
        if (gift?.preorder) {
          return {
            preorder: true,
            message: gift.preorderMessage || defaultPreorderMessage(),
          };
        }

        if (
          this.config.mainPreorder &&
          (id === String(this.config.mainVariantId) ||
            id === String(this.form?.querySelector('[name="id"]')?.value))
        ) {
          return {
            preorder: true,
            message: this.config.mainPreorderMessage || defaultPreorderMessage(),
          };
        }

        return null;
      }

      _buildCartItems(parentQuantity, mainVariantId) {
        const labels = getBundlePropertyLabels(this.config);
        const timeStampValue = String(Date.now());
        const bundleQty = this.getTotalQuantity(this.selection);
        const variantId = String(mainVariantId);
        const mainPreorderState =
          getFormPreorderState(this.form) || this._getPreorderStateForVariant(variantId);

        const mainProperties = {
          [labels.main]: timeStampValue,
        };
        applyPreorderProperties(mainProperties, mainPreorderState);

        const items = [
          {
            id: variantId,
            quantity: parentQuantity,
            properties: mainProperties,
          },
        ];

        this._getSortedSelectionItems(this.selection).forEach((slotItem, index) => {
          const properties = {
            [labels.addons]: timeStampValue,
            _bundle_unit: String(index),
            _bundle_qty_per_parent: "1",
          };

          const addonProperty = this._getAddonPropertyForItem(slotItem, this.selection);
          if (addonProperty) {
            properties[addonProperty.name] = addonProperty.value;
          }

          applyPreorderProperties(properties, this._getPreorderStateForVariant(slotItem.variantId));

          items.push({
            id: String(slotItem.variantId),
            quantity: parentQuantity,
            parent_id: variantId,
            properties,
          });
        });

        const addedGiftVariantIds = new Set();
        this.getUnlockedGifts(bundleQty).forEach((gift) => {
          const giftVariantId = String(gift.variantId);
          if (addedGiftVariantIds.has(giftVariantId)) return;
          addedGiftVariantIds.add(giftVariantId);

          const giftProperties = {
            [labels.addons]: timeStampValue,
            _bundle_gift: "1",
            _bundle_qty_per_parent: "1",
          };
          applyPreorderProperties(giftProperties, this._getPreorderStateForVariant(giftVariantId));

          items.push({
            id: giftVariantId,
            quantity: parentQuantity,
            parent_id: variantId,
            properties: giftProperties,
          });
        });

        return items;
      }

      async _onFormSubmit(event) {
        if (this.isBelowMinQuantity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this._updateMinQuantityState();
          return;
        }

        const bundleQty = this.getTotalQuantity(this.selection);
        const hasUnlockedGifts = this.getUnlockedGifts(bundleQty).length > 0;
        if (bundleQty === 0 && !hasUnlockedGifts) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButtons = this._getSubmitButtons();
        const mainVariantId = String(this.form.querySelector('[name="id"]')?.value);
        const parentQuantity = this._getMainQuantity();
        const items = this._buildCartItems(parentQuantity, mainVariantId);
        const onSuccessDo = new FormData(this.form).get("on_success");

        await submitBundleCart({
          items,
          mainVariantId,
          form: this.form,
          submitButtons,
          onSuccessDo,
        });

        this._updateMinQuantityState();
      }
    }

    function createDetachedBundleEngine(config) {
      const engine = Object.create(BundleBuilder.prototype);
      engine.config = config || {};
      engine.productLookup = buildProductLookup(engine.config);
      engine.tiers = sortTiers(engine.config.discountTiers);
      engine.freeGifts = sortFreeGifts(engine.config.freeGifts);
      engine.selection = new Map();
      engine.preselectedIds = new Set();
      engine._initPreselected();
      return engine;
    }

    const BundleQuickAdd = {
      init() {
        if (this._initialized) return;
        this._initialized = true;
        document.addEventListener("submit", this._onSubmit.bind(this), true);
      },

      _onSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const card = form.closest("[data-bundle-quick-add]");
        const handle =
          card?.getAttribute("data-bundle-quick-add") ||
          form.getAttribute("data-bundle-quick-add") ||
          form.querySelector('[name="bundle_quick_add_handle"]')?.value;
        if (!handle) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.add(handle, form);
      },

      async add(handle, form) {
        const submitButtons = Array.from(form?.elements || []).filter((el) => el.type === "submit");
        submitButtons.forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-busy", "true");
        });

        try {
          const config = await fetchBundleConfigByHandle(handle);
          if (!config) {
            submitButtons.forEach((btn) => {
              btn.removeAttribute("disabled");
              btn.removeAttribute("aria-busy");
            });
            form?.dispatchEvent(
              new CustomEvent("cart:error", {
                bubbles: true,
                detail: { error: "Bundle could not be added. Please open the product page." },
              })
            );
            return;
          }

          const engine = createDetachedBundleEngine(config);
          const mainVariantId = String(
            config.mainVariantId || form.querySelector('[name="id"]')?.value || ""
          );
          const items = engine._buildCartItems(1, mainVariantId);
          const onSuccessDo = form ? new FormData(form).get("on_success") : "force_open_drawer";

          await submitBundleCart({
            items,
            mainVariantId,
            form,
            submitButtons,
            onSuccessDo: onSuccessDo || "force_open_drawer",
          });
        } catch (error) {
          submitButtons.forEach((btn) => {
            btn.removeAttribute("disabled");
            btn.removeAttribute("aria-busy");
          });
          form?.dispatchEvent(
            new CustomEvent("cart:error", {
              bubbles: true,
              detail: { error: error.message },
            })
          );
        }
      },
    };

    const BundleWishlist = {
      init() {
        if (this._initialized) return;
        this._initialized = true;
        document.addEventListener("submit", this._onSubmit.bind(this), true);
        document.addEventListener("click", this._onClick.bind(this), true);
        this._scan();
        this._observer = new MutationObserver(() => this._scan());
        this._observer.observe(document.body || document.documentElement, {
          childList: true,
          subtree: true,
        });
      },

      _isWishlistAtcTarget(event) {
        const card = event.target?.closest?.("wishlist-product-card");
        if (!card) return null;
        const form = event.target.closest("form.wk-form");
        if (!form || !card.contains(form)) return null;
        return card;
      },

      _shouldBlockWishlistAtc(card) {
        return card.dataset.bundleWishlistReady !== "true" || card.dataset.bundleWishlistProduct === "true";
      },

      _onSubmit(event) {
        const card = this._isWishlistAtcTarget(event);
        if (!card || !this._shouldBlockWishlistAtc(card)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },

      _onClick(event) {
        const card = this._isWishlistAtcTarget(event);
        if (!card || !this._shouldBlockWishlistAtc(card)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },

      _cardRoot(card) {
        return card.shadowRoot || card;
      },

      _getAtcForm(card) {
        return this._cardRoot(card).querySelector("form.wk-form") || null;
      },

      _lockAtc(form) {
        if (!form) return;
        form.hidden = true;
        form.setAttribute("aria-hidden", "true");
        form.style.setProperty("display", "none", "important");
        form.style.setProperty("pointer-events", "none", "important");
      },

      _unlockAtc(form) {
        if (!form) return;
        form.hidden = false;
        form.removeAttribute("aria-hidden");
        form.style.removeProperty("display");
        form.style.removeProperty("pointer-events");
      },

      _lockAtcIfNeeded(card) {
        if (card.dataset.bundleWishlistReady === "true" && card.dataset.bundleWishlistProduct !== "true") {
          return;
        }
        this._lockAtc(this._getAtcForm(card));
      },

      _scan() {
        if (this._scanFrame) return;
        this._scanFrame = requestAnimationFrame(() => {
          this._scanFrame = null;
          document.querySelectorAll("wishlist-product-card").forEach((card) => {
            this._lockAtcIfNeeded(card);
            this._handleCard(card);
          });
        });
      },

      async _handleCard(card) {
        this._lockAtcIfNeeded(card);

        if (card.dataset.bundleWishlistProduct === "true") {
          this._renderConfigureButton(card);
          this._renderBundlePrice(card);
          return;
        }

        if (card.dataset.bundleInitialPrice) {
          this._renderBundlePrice(card);
        }

        if (card.dataset.bundleWishlistReady === "true" || card.dataset.bundleWishlistPending === "true") {
          return;
        }

        const handle = this._getHandle(card);
        if (!handle) return;

        card.dataset.bundleWishlistPending = "true";
        const info = await fetchBundleProductInfo(handle);
        card.dataset.bundleWishlistPending = "false";

        if (info.bundleInitialPrice) {
          card.dataset.bundleInitialPrice = info.bundleInitialPrice;
        }

        if (info.isBundleBuilder) {
          card.dataset.bundleWishlistProduct = "true";
        }

        card.dataset.bundleWishlistReady = "true";

        const form = this._getAtcForm(card);

        if (!info.isBundleBuilder) {
          this._unlockAtc(form);
          this._renderBundlePrice(card);
          return;
        }

        this._lockAtc(form);
        this._renderConfigureButton(card);
        this._renderBundlePrice(card);
      },

      _renderBundlePrice(card) {
        const priceText = card.dataset.bundleInitialPrice || "";
        if (!priceText) return;

        const root = this._cardRoot(card);
        let priceEl = root.querySelector(".wk-price");
        if (!priceEl) {
          const meta = root.querySelector(".wk-meta");
          if (!meta) return;
          priceEl = document.createElement("div");
          priceEl.className = "wk-price price-list";
          meta.appendChild(priceEl);
        }

        if (priceEl.dataset.bundlePriceInjected === priceText && priceEl.querySelector("sale-price")) {
          return;
        }

        priceEl.classList.add("price-list", "price-list--bundle");
        priceEl.dataset.bundlePriceInjected = priceText;
        priceEl.replaceChildren();

        const salePrice = document.createElement("sale-price");
        salePrice.className = "h6 wk-current-price";
        salePrice.textContent = priceText;
        priceEl.appendChild(salePrice);
      },

      _renderConfigureButton(card) {
        const root = this._cardRoot(card);
        if (root.querySelector(".bundle-wishlist-configure")) return;

        const handle = this._getHandle(card);
        const productUrl =
          this._getProductUrl(card) ||
          (handle ? `${window.Shopify?.routes?.root || "/"}products/${handle}` : "");
        if (!productUrl) return;

        const button = document.createElement("a");
        button.className = "button bundle-wishlist-configure";
        button.href = productUrl;
        button.textContent =
          window.themeVariables?.settings?.bundleWishlistButtonText || "Jetzt konfigurieren";

        const form = this._getAtcForm(card);
        if (form) {
          form.insertAdjacentElement("afterend", button);
        } else {
          root.appendChild(button);
        }
      },

      _getProductLink(card) {
        return this._cardRoot(card).querySelector('a[href*="/products/"]') || null;
      },

      _getProductUrl(card) {
        return this._getProductLink(card)?.getAttribute("href") || "";
      },

      _getHandle(card) {
        const link = this._getProductLink(card);
        if (!link) return "";
        try {
          const url = new URL(link.getAttribute("href"), window.location.origin);
          return getProductHandleFromPath(url.pathname);
        } catch {
          return "";
        }
      },
    };

    function init() {
      BundleCartSync.init();
      BundleQuickAdd.init();
      BundleWishlist.init();

      if (!customElements.get("bundle-builder")) {
        customElements.define("bundle-builder", BundleBuilder);
      }
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
  